export default __webpack_public_path__ + "static/media/sy-dp1.e287834e.png";